import script from "./CommunicationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunicationTable.vue?vue&type=script&setup=true&lang=js"

import "./CommunicationTable.vue?vue&type=style&index=0&id=0b90629c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b90629c"]])

export default __exports__